<template>
  <div class="request-dates">
    <template v-if="editable">
      <v-row v-for="(d, index) in dates" :key="index" dense align="center">
        <v-col cols="12" sm="7">
          <v-combobox
            :value="d.title"
            :items="titleSuggestions"
            :label="$t('quotations.recipients.dates.title')"
            :placeholder="$t('quotations.recipients.dates.title_placeholder')"
            :disabled="saving"
            append-icon=""
            outlined
            dense
            hide-details
            @input="v => change(index, { title: v })"
          />
        </v-col>
        <v-col cols="10" sm="4">
          <date-picker
            :date="d.dueDate"
            :label="$t('quotations.recipients.dates.due_date')"
            :saving="saving"
            :input-styles="{ outlined: true, dense: true }"
            prepend-inner-icon="mdi-calendar"
            @change="v => change(index, { dueDate: v })"
          />
        </v-col>
        <v-col cols="2" sm="1" class="d-flex justify-end">
          <quotation-icon-button icon="delete" color="error" :tooltip="$t('delete')" :disabled="saving" @click="remove(index)" />
        </v-col>
      </v-row>
      <v-btn text small color="primary" class="px-1" :disabled="saving" @click="add">
        <v-icon left small>mdi-plus</v-icon>
        {{ $t('quotations.recipients.dates.add') }}
      </v-btn>
    </template>

    <template v-else>
      <!-- Tehdyt päivät tiivistetään; avoimet näkyvät aina -->
      <template v-for="{ d, index } in sortedDates">
        <div v-if="!d.doneDate || showDone" :key="index" class="d-flex align-center">
          <v-simple-checkbox
            :value="!!d.doneDate"
            :disabled="readonly || busy"
            :ripple="false"
            color="primary"
            class="mr-1"
            @input="toggle(index)"
          />
          <span class="body-2" :class="stateClass(d)">
            {{ d.title }} {{ $formatDateNoTime(d.dueDate) }}
          </span>
          <span v-if="d.doneDate" class="caption grey--text ml-2">{{ $t('quotations.recipients.dates.done_on', { date: $formatDateNoTime(d.doneDate) }) }}</span>
        </div>
      </template>
      <a v-if="doneCount > 0" href="#" class="caption" @click.prevent="showDone = !showDone">
        <v-icon x-small color="primary">{{ showDone ? 'mdi-chevron-up' : 'mdi-check' }}</v-icon>
        {{ showDone ? $t('quotations.recipients.dates.hide_done') : $t('quotations.recipients.dates.done_count', { n: doneCount }) }}
      </a>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import DatePicker from '@/components/DatePicker';
import QuotationIconButton from './QuotationIconButton';

// Tarjouspyynnön tärkeät päivät (jättöpäivä on erikseen). Muutokset lähetetään aina uutena taulukkona,
// jotta muokkaimen peruutus palauttaa alkuperäiset päivät.
export default {
  name: 'QuotationRequestDates',
  components: { DatePicker, QuotationIconButton },
  props: {
    dates: { type: Array, default: () => [] },
    // Muokkain: kuvaus ja päivä muokattavissa; muuten luettava lista, jossa kuittaus
    editable: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    saving: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
  },
  data() {
    return {
      showDone: false,
      titleSuggestions: [this.$t('quotations.recipients.dates.suggestions.questions'), this.$t('quotations.recipients.dates.suggestions.negotiation')],
    };
  },
  computed: {
    // Päiväjärjestyksessä kuten tallennettuna, myös kun muokkain on suljettu ennen tallennusta.
    // Indeksi viittaa dates-taulukkoon, jota kuittaus muuttaa.
    sortedDates() {
      return this.dates.map((d, index) => ({ d, index })).sort((a, b) => (a.d.dueDate || '').localeCompare(b.d.dueDate || ''));
    },
    doneCount() {
      return this.dates.filter(d => d.doneDate).length;
    },
  },
  methods: {
    change(index, data) {
      this.$emit('change', this.dates.map((d, i) => (i === index ? { ...d, ...data } : d)));
    },
    add() {
      this.$emit('change', [...this.dates, { title: '', dueDate: null, doneDate: null }]);
    },
    remove(index) {
      this.$emit('change', this.dates.filter((d, i) => i !== index));
    },
    toggle(index) {
      const d = this.dates[index];
      this.change(index, { doneDate: d.doneDate ? null : dayjs().format('YYYY-MM-DD') });
    },
    stateClass(d) {
      if (d.doneDate) return 'grey--text text-decoration-line-through';
      return d.dueDate < dayjs().format('YYYY-MM-DD') ? 'error--text' : '';
    },
  },
};
</script>
